import { createContext, useEffect } from "react";

import { useData } from "@shared/hooks";

import { getUserLevelsAccess, getUserData } from "@modules/user/data";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
	const { status, setStatus, error, setError, data, setData } = useData({ defaultData: {} });

	useEffect(() => {
		getUserData({ setData, setStatus });
	}, []);

	return (
		<UserContext.Provider
			value={{
				user: data,
				setUserAccess: setData,
				userStatus: status,
				setUserAccessStatus: setStatus,
				userError: error,
				setUserAccessError: setError,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};
